<template>
  <DBox
    :id="'cmp-catalog-products-advanced_product_setup'"
    :addButton="false"
    :expandable="true"
    :sid="selectedProductDetails.product.product_id"
  >
    <Dropdown2
      deselect
      :label="$t('pricecode')"
      :placeholder="$t('choose') + ' ' + $t('pricecode')"
      :disabled="selectedProductDetails.disabled"
      :options="selectedProductDetails.priceCodesTV"
      :selected="
        selectedProductDetails.priceCodesTV.find(
          (c) => c.value == selectedProductDetails.product.price_code_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('price_code_id', e)"
    />
    <template
      v-if="selectedProductDetails.product.digital_physical == 'digital'"
    >
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'attribute1'"
        :placeholder="$t('info1')"
        :label="$t('info1')"
        :value="selectedProductDetails.product.attribute1"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'attribute2'"
        :placeholder="$t('info2')"
        :label="$t('info2')"
        :value="selectedProductDetails.product.attribute2"
        @blur="onTextFieldValueChange"
      />
      <Dropdown2
        :label="$t('download')"
        :placeholder="$t('choose') + ' ' + $t('download')"
        :disabled="selectedProductDetails.disabled"
        :options="selectedProductDetails.yesNoTV"
        :selected="
          selectedProductDetails.yesNoTV.find(
            (c) => c.value == selectedProductDetails.product.download_yes_no
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('download_yes_no', e)"
      />
      <Dropdown2
        :label="$t('streaming')"
        :placeholder="$t('choose') + ' ' + $t('streaming')"
        :disabled="selectedProductDetails.disabled"
        :options="selectedProductDetails.yesNoTV"
        :selected="
          selectedProductDetails.yesNoTV.find(
            (c) => c.value == selectedProductDetails.product.stream_yes_no
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('stream_yes_no', e)"
      />
    </template>
    <template v-else>
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'ppd'"
        :type="'number'"
        :placeholder="$t('ppd')"
        :label="$t('ppd')"
        :value="selectedProductDetails.product.ppd"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'cost_price'"
        :type="'number'"
        :placeholder="$t('cost_price')"
        :label="$t('cost_price')"
        :value="selectedProductDetails.product.cost_price"
        @blur="onTextFieldValueChange"
      />
      <Dropdown2
        :label="$t('supplier')"
        :placeholder="$t('choose') + ' ' + $t('supplier')"
        :disabled="selectedProductDetails.disabled"
        :options="selectedProductDetails.suppliersTV"
        :selected="
          selectedProductDetails.suppliersTV.find(
            (c) => c.value == selectedProductDetails.product.supplier_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('supplier_id', e)"
      />
      <Dropdown2
        :label="$t('category')"
        :placeholder="$t('choose') + ' ' + $t('category')"
        :disabled="selectedProductDetails.disabled"
        :options="selectedProductDetails.categories1TV"
        :selected="
          selectedProductDetails.categories1TV.find(
            (c) => c.value == selectedProductDetails.product.product_type_id
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('product_type_id', e)"
      />
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'weight'"
        :placeholder="$t('weight')"
        :label="$t('weight')"
        :value="selectedProductDetails.product.weight"
        @blur="onTextFieldValueChange"
      />

      <Dropdown2
        :label="$t('language')"
        :placeholder="$t('choose') + ' ' + $t('language')"
        :disabled="selectedProductDetails.disabled"
        :options="selectedProductDetails.track_product_languagesTV"
        :selected="
          selectedProductDetails.track_product_languagesTV.find(
            (c) => c.value == selectedProductDetails.product.language
          )
        "
        v-on:selectedChange="(e) => onDropdownChange('language', e)"
      />
      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'attribute1'"
        :placeholder="$t('size')"
        :label="$t('size')"
        :value="selectedProductDetails.product.attribute1"
        @blur="onTextFieldValueChange"
      />

      <TextField2
        :disabled="selectedProductDetails.disabled"
        :id="'attribute2'"
        :placeholder="$t('colour')"
        :label="$t('colour')"
        :value="selectedProductDetails.product.attribute2"
        @blur="onTextFieldValueChange"
      />
    </template>

    <Dropdown2
      :label="$t('category_2')"
      :placeholder="$t('choose') + ' ' + $t('category_2')"
      :disabled="selectedProductDetails.disabled"
      :options="selectedProductDetails.categories2TV"
      :selected="
        selectedProductDetails.categories2TV.find(
          (c) => c.value == selectedProductDetails.product.product_type_id2
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('product_type_id2', e)"
    />
    <TextField2
      :disabled="selectedProductDetails.disabled"
      :id="'attribute3'"
      :placeholder="$t('add_info')"
      :label="$t('add_info')"
      :value="selectedProductDetails.product.attribute3"
      @blur="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
    isPhysical: {
      required: true,
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-advanced_product_setup {
}
</style>
